import { useState } from "react";

import { CloseOutlineIconComponent } from "assets/icons";
import styles from "./styles.module.scss";

function Alert({ type, icon, text, actionBtn, onCloseNotif = () => {} }) {
  const [showAlert, setShowAlert] = useState(true);

  const handleClickCloseBtn = () => {
    setShowAlert(false);
    onCloseNotif();
  };

  if (showAlert) {
    return (
      <div data-type={type} className={styles.notification__alert}>
        <div className={styles.notification__alert__inner}>
          <div className={styles.notification__alert__icon}>{icon}</div>
          <span>{text}</span>
          {actionBtn}
        </div>

        <div
          onClick={handleClickCloseBtn}
          className={styles.notification__alert__close}
        >
          <CloseOutlineIconComponent />
        </div>
      </div>
    );
  }

  return null;
}

export default Alert;
